import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

/**
 * Diese Direktive damit ein Element zu einem Icon-Button zu machen.
 * Nimmt ein Attribut, das als Icon Name dient
 *
 * Beispiel:
 * <button ibtn="new" type="button"></button>
 */
@Directive({
    selector: '[ibtn]',
    host: { class: 'ibtn' }
})
export class IconButtonDirective implements OnChanges {
    @Input('ibtn') icon;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngOnChanges(_: SimpleChanges) {
        const iconClass = 'icon-' + this.icon;
        this.renderer.addClass(this.el.nativeElement, iconClass);
    }
}
